import { GenericChartInterface } from 'app/reports/models';

import { DataSeriesInterface } from 'app/reports/models/data-series.model';

import { DataPointInterface } from 'app/reports/models/data-point.model';

export function getDeepCopyOfObject(object: {}): {} {
  return JSON.parse(JSON.stringify(object));
}

export function removeByKey(array: any[], params: any): any[] {
  array.some((item: any, index: number) => {
    if(array[index][params.key] === params.value) {
      // found it!
      array.splice(index, 1);
      return true; // stops the loop
    }
    return false;
  });
  return array;
}

export function validatePasswordStrength(password: string): boolean {
  const hasNumber: boolean = /\d/.test(password);
  const hasUpper: boolean = /[A-Z]/.test(password);
  const hasLower: boolean = /[a-z]/.test(password);
  const hasLength: boolean = password ? password.length > 9 : false;

  return hasNumber && hasUpper && hasLower && hasLength;
}

export function concatChartDetailsArrays(chartData: GenericChartInterface): number[] {
  return concatChartSeriesArrays(chartData.series);
}

export function concatChartSeriesArrays(series: DataSeriesInterface[]): number[] {
  let concatenatedArray: number[] = [];

  series.forEach((serie: DataSeriesInterface) => {
    serie.series.forEach((dataPoint: DataPointInterface)=> {
      // concat and only add if not a dupe
      concatenatedArray = Array.from(new Set(concatenatedArray.concat(dataPoint.details)));
    });
  });

  return concatenatedArray;
}

export function concatChartSeriesDetails(serie: DataSeriesInterface): number[] {
  let concatenatedArray: number[] = [];

  serie.series.forEach((dataPoint: DataPointInterface)=> {
    // concat and only add if not a dupe
    concatenatedArray = Array.from(new Set(concatenatedArray.concat(dataPoint.details)));
  });

  return concatenatedArray;
}

export function stringDecodeToHtml(stringToDecode: string): string {
  let result: string;
  if (stringToDecode) {
    result = b64DecodeUnicode(stringToDecode);
  } else {
    result = undefined;
  }
  return result;
}

export function stringEncodeToB64(stringToEncode: string): string {
  let result: string;
  if (stringToEncode) {
    result = btoa(stringToEncode.replace(/[\u00A0-\u2666]/g, (c: string) => {
      return '&#' + c.charCodeAt(0) + ';';
    }));
    // result = window.btoa(stringToEncode);
  } else {
    result = undefined;
  }
  return result;
}

function b64DecodeUnicode(str: string): string {
  let result: string = '';
  // Going backwards: from bytestream, to percent-encoding, to original string.
  try {
    result = decodeURIComponent(atob(str).split('').map((c: string) => {
       return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  } catch {
    result = window.btoa(str);
  }
  return result;
}
